import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux";
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../../assets/images/users/avatar-4.jpg"

//i18n
import { withTranslation } from "react-i18next"

import {
  getUserUnlockInfo as onGetRemainUnlockCnt,
} from "../../../store/actions";

import SweetAlert from "react-bootstrap-sweetalert";
import LoadingModal from "../../../components/Common/LoadingModal"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const dispatch = useDispatch();

  const { remainUnlockCnt, unlockHistory, loading, errorMessage } = useSelector(state => ({
    remainUnlockCnt: state.Unlock.remainUnlockCnt,
    unlockHistory: state.Unlock.unlockHistory,
    loading: state.Unlock.loading,
    errorMessage: state.Unlock.errorMessage,
  }));

  useEffect(() => { 
    dispatch(onGetRemainUnlockCnt());
  }, []);

  return (
    <>
      {errorMessage !== "" ?
      <SweetAlert>
        {errorMessage}
      </SweetAlert>
      : null
      }
      {
        loading ?
        <LoadingModal loading={loading}></LoadingModal>
        : null
      }
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="uil-bell"></i>
          <span className="badge bg-danger rounded-pill">{remainUnlockCnt}</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 font-size-16"> {props.t("Unlock History")} </h6>
              </Col>
              {/*
              <div className="col-auto">
                <a href="#!" className="small">
                  {" "}
                  Mark all as read
                </a>
              </div>
              */}
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {
              unlockHistory.map((unlock, index) => {
                  return (
                    <Link to="" className="text-reset notification-item">
                      <div className="d-flex align-items-start">
                        <div className="avatar-xs me-3" style={unlock.unlockType === 'Filer' ? {width: '3rem'} : null}>
                          <span className={unlock.unlockType === 'Madrid' ?  "avatar-title bg-primary rounded-circle font-size-16" : "avatar-title bg-success rounded-circle font-size-16"}>
                          <i className={unlock.unlockType === 'Madrid' ?  "uil-envelopes" : "uil-medal"}></i>
                          </span>
                        </div>
                        <div className="flex-1">
                          <h6 className="mt-0 mb-1">
                          {unlock.unlockType === 'Madrid' ? "Madrid Notifier case unlocked" : "Filer Ranking entity unlocked"}
                          </h6>
                          <div className="font-size-12 text-muted">
                            <p className="mb-1">
                            {unlock.unlockType === 'Madrid' ? "Irn : " + unlock.irNumber + ", Jr : " + unlock.crCode : "Entity : " + unlock.targetGroupName}
                            </p>
                            {/*
                            <p className="mb-0">
                            <i className="mdi mdi-clock-outline"></i>{" "}
                              {props.t("3 min ago")}{" "}
                            </p>
                            */}
                          </div>
                        </div>
                      </div>
                    </Link>
                  )
                })
              }
            {/*
            <Link to="" className="text-reset notification-item">
              <div className="d-flex align-items-start">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-primary rounded-circle font-size-16">
                  <i className="uil-shopping-basket"></i>
                  </span>
                </div>
                <div className="flex-1">
                  <h6 className="mt-0 mb-1">
                    {props.t("Your order is placed")}
                  </h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t("If several languages coalesce the grammar")}
                    </p>
                    <p className="mb-0">
                    <i className="mdi mdi-clock-outline"></i>{" "}
                      {props.t("3 min ago")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="d-flex align-items-start">
                <img
                  src={avatar3}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div className="flex-1">
                  <h6 className="mt-0 mb-1">James Lemire</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t("It will seem like simplified English") + "."}
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline"/>
                      {props.t("1 hours ago")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="d-flex align-items-start">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-success rounded-circle font-size-16">
                    <i className="bx bx-badge-check"/>
                  </span>
                </div>
                <div className="flex-1">
                  <h6 className="mt-0 mb-1">
                    {props.t("Your item is shipped")}
                  </h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t("If several languages coalesce the grammar")}
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline"/>{" "}
                      {props.t("3 min ago")}
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="" className="text-reset notification-item">
              <div className="d-flex align-items-start">
                <img
                  src={avatar4}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div className="flex-1">
                  <h6 className="mt-0 mb-1">Salena Layfield</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t(
                        "As a skeptical Cambridge friend of mine occidental"
                      ) + "."}
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline"/>
                      {props.t("1 hours ago")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            */}
          </SimpleBar>
          {/*
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to="#"
            ><i className="uil-arrow-circle-right me-1"></i>
              {" "}
              {props.t("View all")}{" "}
            </Link>
          </div>
          */}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any
}